import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'

export interface SandboxChatUser {
  sub: string
  email: string
  emailVerified: boolean
  name?: string
  picture?: string
}

export const signInSandboxChatUser = async (auth: firebase.auth.Auth, user: SandboxChatUser): Promise<void> => {
  // Mock Google credentials are supported only by the Auth emulator, never production.
  const { projectId } = auth.app.options as { projectId?: string }
  if (!auth.emulatorConfig || !projectId?.startsWith('demo-')) {
    throw new Error('Chat account provisioning requires the project Auth emulator.')
  }
  if (typeof user.sub !== 'string' || !user.sub || typeof user.email !== 'string' || !user.email) {
    throw new Error('Chat account provisioning requires a user identity and email.')
  }

  try {
    await auth.signInWithCredential(
      firebase.auth.GoogleAuthProvider.credential(
        JSON.stringify({
          sub: user.sub,
          email: user.email,
          email_verified: user.emailVerified === true,
          name: user.name,
          picture: user.picture,
        })
      )
    )
  } catch {
    // The Chat startup boundary keeps the application closed on failure.
    // Do not sign out a session that another sign-in may have established.
    throw new Error('Chat sign-in failed. Leave Chat and reopen it to retry.')
  }
}
